export const getHeadingIcon = (level: number | undefined): string => {
  switch (level) {
    case 1:
      return 'gem-h1'
    case 2:
      return 'gem-h2'
    case 3:
      return 'gem-h3'
    case 4:
      return 'gem-h4'
    default:
      return 'gem-paragraph'
  }
}

export const getAlignIcon = (align: string): string => {
  switch (align) {
    case 'center':
      return 'gem-align-center'
    case 'right':
      return 'gem-align-right'
    case 'justify':
      return 'gem-align-justified'
    default:
      return 'gem-align-left'
  }
}

export const getListIcon = (listType: string | undefined): string => {
  switch (listType) {
    case 'bulletList':
      return 'gem-bullet-list'
    case 'orderedList':
      return 'gem-numbered-list'
    case 'taskList':
      return 'gem-add-checkbox'
    default:
      return 'gem-bullet-list'
  }
}
